import React from 'react';
import { TopicStyles } from './mixins/mixins';
import { SidebarBackgroundValues } from './mixins/optionsValues';
import { StyleDropdownMenu, StyleSlider } from './components/common';

export const SidebarStyle = ({
	style,
	setStyle
}: {
	style: TopicStyles;
	setStyle: (style: TopicStyles) => void;
}) => {
	return (
		<div className="grid grid-cols-2 lg:grid-cols-3 justify-items-center gap-4">
			<StyleDropdownMenu
				key={'view'}
				name={'View'}
				options={[
					{ name: 'Solid', value: SidebarBackgroundValues.SOLID },
					{ name: 'Floating', value: SidebarBackgroundValues.FLOATING }
				]}
				handleChange={(value: any) => {
					setStyle({
						...style,
						sidebarStyle: { ...style.sidebarStyle, ['view']: value }
					});
				}}
				optionState={style.sidebarStyle.view}
			/>

			<StyleSlider
				key={'sidebar-width'}
				id={'sidebar-width'}
				name={'Width'}
				initialValue={style.sidebarStyle.width}
				minValue={'30'}
				maxValue={'50'}
				step={'1'}
				handleChange={({ value }: { value: any }) => {
					setStyle({
						...style,
						sidebarStyle: { ...style.sidebarStyle, ['width']: value }
					});
				}}
			/>

			<StyleSlider
				key={'sidebar-content-width'}
				id={'sidebar-content-width'}
				name={'Content Width'}
				initialValue={style.sidebarStyle.contentWidth}
				minValue={'360'}
				maxValue={'1044'}
				step={'20'}
				handleChange={({ value }: { value: any }) => {
					setStyle({
						...style,
						sidebarStyle: { ...style.sidebarStyle, ['contentWidth']: value }
					});
				}}
			/>
		</div>
	);
};
